module.exports = __webpack_public_path__ + "static/media/lifestyleGuitar-large.dced07a7.jpg";